//import Plyr from 'plyr';
import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';
//import { ScrollTrigger } from 'gsap/ScrollTrigger';
//gsap.registerPlugin( ScrollTrigger);

// Vimeo Player SDK:  https://developer.vimeo.com/player/sdk
const console = window.console;

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false,

        	debug: true
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'embed_video_player';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		this.$window 		= 	$(window);

		this.init( true );
    }

    init( b ){
    	this.$iframe = this.$el.find( 'iframe' );

    	let has_script = this.$el.find( '.video-to-load' ).length > 0;

    	//console.log( this.$el.find( '.video-to-load' ) )

    	if ( this.$iframe.length <= 0 && !has_script ){
    		this.onError(  {name: 'missing element', message:'iframe is missing'} );
    		return;
    	}

    	//console.log( 'hello' )

    	//this.initPlayer( b );
    	this.addEvents( b );

		// if the placeholder (video-poster) is specified, set video embed to visible
		if ( this.$el.find( '.placeholder' ).length > 0 ){
			this.$el.addClass( 'video-load' );
		}    	
	}

	revealVideoPoster(){

		let $script = this.$el.find( '.video-to-load' );
		
		if ( $script.length > 0 ){
			this.$el.find( '.video-wrapper' ).append( $script.html() );
			$script.remove();
			this.onResize()
		}
	
		this.$el.off( 'click', () => this.revealVideoPoster() );
		gsap.to( this.$el.find( 'img' ), {opacity:0,duration:0.3,onComplete:()=>{
			this.$el.find( 'img' ).remove()
		}} );
		gsap.to( this.$el.find( 'svg' ), {opacity:0,duration:0.3,onComplete:()=>{
			this.$el.find( 'svg' ).remove()
		}} );
		this.$el.removeClass( 'has-poster' );
	}


	 //---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.$el.on( 'click', () => this.revealVideoPoster() );
		}
		this.debounceResize(b);
	}

    debounceResize( b ){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 77 );
			this.$window.on( 'resize', this._debResize );

			this.onResize()
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$window.off( 'resize', this._debResize );
			}        
		}
    }


    onResize(){
    	let $iframe = this.$el.find( 'iframe' ), 
    		$wrapper  = this.$el.find( '.video-wrapper' ),
    		w_video, h_video;
    		
    	if ( $iframe.length > 0  ){
    		w_video = parseInt( $iframe.attr('width')  ), 
    		h_video = parseInt( $iframe.attr('height') );

    		if ( $wrapper.length > 0 && h_video && w_video ){
    			$wrapper.css({
    				'padding-bottom' : (100*h_video/w_video) + '%'
    			})
    		}
    	}
    }

    //---------------------------------------- METHODS ---------------------------------------//
    play( b ){
    	if ( b ){
    	}
    	else{
    	}
	}

    togglePlay(){
    }

    // fired by ScrollTrigger if this.options.autopause is true
    forceAutoPause( b ){
    }

    destroy(){
    	this.init( false );
    }

}


